import styles from "../Subscription/Subscription.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SublyApi from "../../helpers/Api";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HomePageSlider from "../../commonComponents/HomePageSlider/HomePageSlider";
import SubHeader from "../HeaderSection/SubHeader";
import { STATUS_CODES } from "../../utils/StatusCode";
import Loader from "../../utils/Loader/Loader";
import $ from "jquery";
import FooterSection from "../FooterSection/FooterSection";
import { GetHomePage, userLogoutClear } from "../../store/slices/UserSlice";

//---------function for subscription page---------- 
function Subscription() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser, userToken } = useSelector((state) => state.user);
  const [packageList, setPackageList] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { homePageData } = useSelector((state) => state.user);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  // Effect to handle resize event and update the isMobile state
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // --------function for open component top of the page ----------
  useEffect(() => {
    $("document").ready(function () {
      $(window).scrollTop(0);
    });
  }, []);

  //---------function for subscription api calling----------
  useEffect(() => {
    async function subscriptionPackageList() {
      setIsLoading(true);
      const details = await SublyApi.getPackageList();
      setIsLoading(false);
      if (details && details.settings && details.settings.success && details.settings.success == STATUS_CODES.SUCCESS_API) {
        setPackageList(details && details.data);
        setSliderTitle(details && details?.data?.get_trainer_title);
      }
    }
    subscriptionPackageList();
    dispatch(GetHomePage({ authToken: userToken || null }))
  }, []);

function parseTextWithLinks(text) {
  const urlRegex = /(\b(?:https?:\/\/|www\.)[^\s]+)/g;
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // Remove trailing punctuation (.,!?) from the URL
      const cleanedUrl = part.replace(/[.,!?;]*$/, "");
      const href = cleanedUrl.startsWith("http") ? cleanedUrl : `https://${cleanedUrl}`;

      return (
        <a
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{textDecoration: "underline" }}
        >
          {cleanedUrl}
        </a>
      );
    }
    return <span key={index}>{part}</span>;
  });
}


const handleLoginRedirect = (packageDetail) => {
  const host = window.location.hostname;
  let subdomain = "";
  const parts = host.split(".");
  if (host.endsWith(".3fitstyle.com")) {
    if (parts.length === 3 && parts[0] !== "www") {
      subdomain = parts[0];
    } else if (parts.length === 4 && parts[0] === "www") {
      subdomain = parts[1];
    }
  }

  dispatch(userLogoutClear());

  // Add state to query params
  // const packageQuery = packageDetail
  //   ? `packageName=true&packageDetail=${encodeURIComponent(JSON.stringify(packageDetail))}`
  //   : "";

  if (subdomain) {
    document.cookie = `subdomain=${subdomain}; path=/; domain=.3fitstyle.com`;
    window.location.href = `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}login?subdomain=${subdomain}&packageName=true&id=${packageDetail?.id}`;
  } else {
    document.cookie = "subdomain=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.3fitstyle.com";
    window.location.href = `https://${process.env.REACT_APP_MAIN_URL}${process.env.REACT_APP_PARAM_URL}login?packageName=true&id=${packageDetail?.id}`;
  }
};

  return (
    <>
      {isLoading === true ? <Loader /> :
        (
          <>
            <SubHeader />
            <div className="main">
              <Container>
                <div className="boxWrapper">
                  <div className="innerboxWrapper">

                    {packageList ?
                      <div>

                        {packageList && packageList.get_static_content.length >= 1 && (
                          <div className="text-center">
                            <div className={styles.subscriptionOffer}>
                              <div className="heading" style={{ lineHeight: "30px" }}>
                                <h2>{packageList.get_static_content[0].title}</h2>
                              </div>
                              <p>{packageList.get_static_content[0].content}</p>
                            </div>
                          </div>
                        )}
                        {packageList && packageList.get_all_packages.length < 3 ? (
                          <Row className={styles.subscriptionInner}>
                            {packageList && packageList.get_all_packages.length > 0 &&
                              packageList.get_all_packages.map((item, index) => (
                                <Col
                                  lg={4}
                                  md={6}
                                  sm={6}
                                  xs={6}
                                  className={styles.subRow}
                                  key={item.index}
                                >
                                  <div
                                    className={styles.subscriptionbox}
                                    style={{
                                      background: `${item.color_code}`,
                                    }}
                                  >
                                    {item?.isTag == 1 ? <span className={styles.label}>{item?.vtagName}</span> : <span className={styles.label} style={{
                                      background: `${item.color_code}`,
                                    }}>

                                    </span>}
                                    <p className={styles.timeSection}>
                                      {item.package_name}
                                    </p>
                                    <div className={styles.subText}>
                                      <p>{item.package_description}</p>
                                    </div>
                                    <div className={styles.amountSection}>
                                      {item.subscription_amount &&
                                        <p>
                                          $<span>{item.subscription_amount}</span>
                                        </p>}
                                      <p className={styles.monthText}></p>
                                    </div>
                                    <div className={styles.subBtn}>
                                      {Object.keys(currentUser).length == 0 ? (
                                        <button
                                          // onClick={
                                          //   () => {
                                          //   navigate("/login", {
                                          //     state: {
                                          //       packageName: true,
                                          //       packageDetail: item,
                                          //     },
                                          //   });
                                          // }}
                                          onClick={() => handleLoginRedirect(item)}
                                        >
                                          {t("SUBSCRIBE")}
                                        </button>
                                      ) : (
                                        <button
                                          onClick={() =>
                                            navigate(`/subscription/detail?id=${item?.id}`, {
                                              // state: {
                                              //   packageName: true,
                                              //   packageDetail: item,
                                              // },
                                            })

                                          }
                                        >
                                          {t("SUBSCRIBE")}
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </Col>
                              ))}
                          </Row>
                        ) : (
                          <Row className={styles.subscriptionInners}>
                            {packageList && packageList.get_all_packages.length > 0 &&
                              packageList.get_all_packages.map((item, index) => (
                                <>
                                  <Col
                                    lg={4}
                                    md={3}
                                    sm={6}
                                    xs={6}
                                    className={styles.subRow}
                                    key={item.index}
                                  >
                                    <div
                                      className={styles.subscriptionbox}
                                      style={{
                                        background: `${item.color_code}`,
                                      }}
                                    >
                                      {item?.isTag == 1 ? <span className={styles.label}>{item?.vtagName}</span> : <span className={styles.label} style={{
                                        background: `${item.color_code}`,
                                      }}>

                                      </span>}
                                      <div className={styles.subContent}>
                                        <p className={styles.timeSection}>
                                          {item.package_name}
                                        </p>

                                        <div className={styles.subText}>
                                          <p>{item.package_description}</p>
                                        </div>
                                      </div>
                                      <div className={styles.amountSection}>
                                        {item.subscription_amount &&
                                          <p>
                                            $<span>{item.subscription_amount}</span>
                                          </p>}
                                        <p className={styles.monthText}></p>
                                      </div>
                                      <div className={styles.subBtn}>
                                        {Object.keys(currentUser).length == 0 ? (
                                          <button
                                            // onClick={() => {
                                            //   navigate("/login", {
                                            //     state: {
                                            //       packageName: true,
                                            //       packageDetail: item,
                                            //     },
                                            //   });
                                            // }}
                                            onClick={() => handleLoginRedirect(item)}
                                          >
                                            {t("SUBSCRIBE")}
                                          </button>
                                        ) : (
                                          <button
                                            onClick={() =>
                                              navigate(`/subscription/detail?id=${item?.id}`, {
                                                // state: {
                                                //   packageName: true,
                                                //   packageDetail: item,
                                                // },
                                              })
                                            }
                                          >
                                            {t("SUBSCRIBE")}
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </Col>
                                </>
                              ))}
                          </Row>
                        )}

                        {!isMobile && <div className={styles.borderBottom}>
                          <span></span>
                        </div>}


                        {packageList && packageList.get_static_content.length > 1 && (
                          packageList.get_static_content.slice(1).map((item, index) => (
                            <div className={styles.subscriptionOffer} key={index}>
                              <div className={styles.middle_hadding}>
                                <h2>{item.title}</h2>
                              </div>
                              <p>{item.content}</p>
                              {!isMobile &&<div className={styles.borderBottom}>
                                <span></span>
                              </div>}
                            </div>
                          ))
                        )}

                        {/* <div className="sliderContent">
                          {homePageData?.middleImage?.length > 0 &&
                            <div className={styles.subBorder}>
                              <div className={styles.storyTittle}>

                              </div>
                              <div className={styles.middle_hadding}>
                                <h2>{homePageData?.our_trainer_title}</h2>
                              </div>
                              <HomePageSlider packageList={homePageData?.middleImage} />
                            </div>
                          }
                        </div> */}

                        {/* {!isMobile && <div className={styles.borderBottom}>
                          <span></span>
                        </div>} */}

                        <div className="sliderContent">
                          {packageList.get_success_story?.length > 0 &&
                            <div className={styles.subBorder}>
                              <div className={styles.storyTittle}>

                              </div>
                              <div className={styles.middle_hadding}>
                                <h2>{sliderTitle}</h2>
                              </div>
                              <HomePageSlider packageList={packageList?.get_success_story} />
                            </div>
                          }
                        </div>
                        <div>
                          {packageList &&
                            <div className={styles.borderBottom}>
                              <span></span>
                            </div>
                          }
                        </div>

                        <div>
                          {packageList && packageList.get_subscription_terms.length > 0 &&
                            packageList.get_subscription_terms.map((item, index) => (
                              <div key={index}>
                                <div className={styles.subTerms}>
                                  <div className="heading">
                                    <h2>{item.title}</h2>
                                  </div>
                                  <p>{parseTextWithLinks(item.content)}</p>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div> : ""
                    }

                  </div>
                </div>
              </Container>
            </div>
            <FooterSection />
          </>
        )}
    </>
  );
}
export default Subscription;
